
import React, { useState } from 'react';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { MetricsSection } from './components/MetricsSection';
import { ChatDemoSection } from './components/ChatDemoSection';
import { AgentsSection } from './components/AgentsSection';
import { AgentDetailsSection } from './components/AgentDetailsSection';
import { PricingPlansSection } from './components/PricingPlansSection';
import { PurchaseSection } from './components/PurchaseSection';
import { DemoFormSection } from './components/DemoFormSection';
import { FAQSection } from './components/FAQSection';

const HomePage: React.FC = () => {
  const [selectedAgentId, setSelectedAgentId] = useState<string>('mina');

  return (
    <div className="min-h-screen bg-dark">
      <Navbar />
      <HeroSection />
      <ChatDemoSection />
      <MetricsSection />
      <AgentsSection onAgentSelect={setSelectedAgentId} />
      <AgentDetailsSection selectedAgentId={selectedAgentId} />
      <PricingPlansSection />
      <PurchaseSection />
      <DemoFormSection />
      <FAQSection />
      <Footer />
    </div>
  );
};

export default HomePage;
